"use client";

import { c as _c } from "react/compiler-runtime";
import { useCookieConsent } from "@/components/cookies/CookieConsentContext";
import useCapacitor from "@/hooks/useCapacitor";
import { ManifoldClaimStatus, ManifoldPhase, useMemesManifoldClaim } from "@/hooks/useManifoldClaim";
import MintCountdownBox from "./MintCountdownBox";
export default function MemePageMintCountdown(props) {
  const $ = _c(9);
  const manifoldClaim = useMemesManifoldClaim(props.nft_id);
  const {
    isIos
  } = useCapacitor();
  const {
    country
  } = useCookieConsent();
  let t0;
  if ($[0] !== manifoldClaim) {
    t0 = () => {
      if (!manifoldClaim) {
        return;
      }
      const phaseName = manifoldClaim.phase === ManifoldPhase.ALLOWLIST && manifoldClaim.memePhase ? manifoldClaim.memePhase.name : manifoldClaim.phase;
      const title = manifoldClaim.status === ManifoldClaimStatus.UPCOMING ? `${phaseName} Starts In` : `${phaseName} Ends In`;
      const date = manifoldClaim.status === ManifoldClaimStatus.UPCOMING ? manifoldClaim.startDate : manifoldClaim.endDate;
      const showAllowlistInfo = manifoldClaim.phase === ManifoldPhase.ALLOWLIST;
      const isFinalized = manifoldClaim.isFinalized;
      const isSoldOut = manifoldClaim.isSoldOut;
      const isEnded = manifoldClaim.status === ManifoldClaimStatus.ENDED;
      return {
        title,
        date,
        showAllowlistInfo,
        isFinalized,
        isEnded,
        isSoldOut
      };
    };
    $[0] = manifoldClaim;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getMintInfo = t0;
  const hideMintBtn = props.hide_mint_btn || isIos && country !== "US";
  let t1;
  if ($[2] !== getMintInfo) {
    t1 = getMintInfo();
    $[2] = getMintInfo;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      href: "/the-memes/mint",
      target: "_self"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== hideMintBtn || $[6] !== props.hide_mint_btn || $[7] !== t1) {
    t3 = <MintCountdownBox mintInfo={t1} linkInfo={t2} hideMintBtn={hideMintBtn} small={props.hide_mint_btn} />;
    $[5] = hideMintBtn;
    $[6] = props.hide_mint_btn;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}